import {Component, EventEmitter, OnInit} from '@angular/core';
import {ProgressIndicatorService} from '../../../@shared';
import {HttpResponseDto, QuotationControllerService, RfqListDto, RfqListItemDto} from '../../../@api';
import {RecipientDto} from './recipient-dto';
import {Router} from '@angular/router';

@Component({
    selector: 'secure-dashboard-rfqs',
    templateUrl: './rfqs.component.html',
    styleUrls: ['./rfqs.component.scss']
})
export class RfqsComponent implements OnInit {

    toggleRecipientDialog: EventEmitter<boolean> = new EventEmitter<boolean>();
    results: RfqListItemDto[] = [];
    cols: any[] = [];
    rfq: RfqListItemDto = {};
    
    constructor(private router: Router,
                private progressIndicatorService: ProgressIndicatorService,
                private quotationService: QuotationControllerService) {
        console.log('RfqsComponent constructor()');
        this.showProgress();
    }
    
    ngOnInit(): void {
        this.cols = [
            { header: 'Number', field: 'number' },
            { header: 'Status', field: 'status' },
            { header: 'Type', field: 'type' },
            { header: 'Due', field: 'dueDate' },
            { header: 'Full Name', field: 'fullName' },
            { header: 'Phone', field: 'phone' },
            { header: 'Email', field: 'email' },
            { header: 'Quoted', field: 'quoted' },
            { header: 'Sent', field: 'sent' }
        ];

        this.quotationService.findAllRfqRecords().subscribe((response: RfqListDto): void => {
            this.results = response.results;
            this.hideProgress(1000);
        }, error => {
            console.log(error);
            this.hideProgress(500);
        });
    }

    showProgress(): void {
        this.progressIndicatorService.publish(true);
    }

    hideProgress(delay): void {
        setTimeout((): void => {
            this.progressIndicatorService.publish(false);
        }, delay);
    }

    openRecipientDialog(rfq: RfqListItemDto): void {
        this.rfq = rfq;
        this.toggleRecipientDialog.emit(true);
    }

    onRecipientSubmit(recipient: RecipientDto): void {
        this.quotationService.mailRfqQuotations({id: this.rfq.id, data: recipient.recipient}).subscribe((response: HttpResponseDto): void => {
            console.log(JSON.stringify(response));
        }, error => {
            console.log(error);
        });
    }

    find(rfqNumber: string): void {
        this.router.navigate(['/secure/dashboard/rfqs', rfqNumber]);
    }
}
